import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Divider,
  Icon
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardRehabHistoryUX = (props: any) => {
    return(
      <div
        id="CardRehabHistoryUX-div-0"
        style={{margin:"0px 10px", paddingBottom: "2rem"}}>
        <div
          id="CardRehabHistoryUX-div-1"
          style={{fontWeight:"bold",fontSize:"large",color:"rgba(0, 114, 188, 1)",margin:"10px 0px"}}>
          {props.languageUX === "en" ? "Treatment History List" : "รายการประวัติการรักษา"}
        </div>
        <div
          className="ui form size small"
          id="CardRehabHistoryUX-div-2">

          <FormGroup
            id="CardRehabHistoryUX-FormGroup-63"
            inline={true}>
            <FormField
              id="CardRehabHistoryUX-FormField-64"
              inline={true}>
              <label
                id="CardRehabHistoryUX-label-69">
                {props.languageUX === "en" ? "Performed date :" : "วันที่ดำเนินการ :"}
              </label>
            </FormField>
            <FormField
              id="CardRehabHistoryUX-FormField-65"
              inline={true}>
              <div
                id="CardRehabHistoryUX-div-71">

                <DateTextBox
                  id="CardRehabHistoryUX-DateTextBox-73"
                  onChange={props.onChangeDate?.("startDate")}
                  value={props.filter?.startDate}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardRehabHistoryUX-FormField-66"
              inline={true}>
              <label
                id="CardRehabHistoryUX-label-70">
                {props.languageUX === "en" ? "to" : "ถึง"}
              </label>
            </FormField>
            <FormField
              id="CardRehabHistoryUX-FormField-67"
              inline={true}>
              <div
                id="CardRehabHistoryUX-div-72">

                <DateTextBox
                  id="CardRehabHistoryUX-DateTextBox-74"
                  onChange={props.onChangeDate?.("endDate")}
                  value={props.filter?.endDate}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardRehabHistoryUX-FormField-68">
              <div
                id="CardRehabHistoryUX-div-75">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardRehabHistoryUX-div-8">
          {props.table}
        </div>
        <div
          id="CardRehabHistoryUX-div-77"
          style={{display: props.data?"":"none"}}>

          <Divider
            id="CardRehabHistoryUX-Divider-78">
          </Divider>
          <div
            className="ui form"
            id="CardRehabHistoryUX-div-80"
            style={{marginTop: "-0.25rem", padding: "0 1rem"}}>

            <div
              id="CardRehabHistoryUX-div-81"
              style={{color: "rgba(0, 114, 188, 1)", fontWeight: "bold", fontSize: "1.15rem", display: "flex", alignItems: "baseline"}}>

              <div
                id="CardRehabHistoryUX-div-123">
                {props.languageUX === "en" ? "Treatment history" : "ประวัติการรักษา"}
              </div>
              <div
                style={{marginLeft: "1rem"}}>
                {props.buttonPrintReport}
              </div>
              <div
                style={{flex:1}}>

              </div>
              <div
                id="CardRehabHistoryUX-div-124">

                <Icon
                  color="red"
                  id="CardRehabHistoryUX-Icon-125"
                  link={true}
                  name="close"
                  onClick={props.onClose}>
                </Icon>
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-82"
              style={{fontWeight: "bold", margin: "1rem 0px 0.5rem"}}>
              Treatment order :
            </div>
            <div
              id="CardRehabHistoryUX-div-83">
              {props.treatmentOrders}
            </div>
            <div
              id="CardRehabHistoryUX-div-84"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>
              {props.languageUX === "en" ? "Procedure code" : "รหัสขั้นตอน"}
            </div>
            <div
              id="CardRehabHistoryUX-div-85"
              style={{display: "flex"}}>

              <div
                id="CardRehabHistoryUX-div-87"
                style={{width: "150px"}}>
                {props.languageUX === "en" ? "Principal procedure :" : "ขั้นตอนหลัก :"}
              </div>
              <div
                id="CardRehabHistoryUX-div-88">
                {props.data?.principal_procedure?.icd9cm?`[${props.data.principal_procedure.icd9cm_code}] ${props.data.principal_procedure.icd9cm_term}`:"-"}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-86"
              style={{display: "flex", marginTop: "0.25rem"}}>

              <div
                id="CardRehabHistoryUX-div-89"
                style={{width: "150px"}}>
                {props.languageUX === "en" ? "Secondary procedure :" : "ขั้นตอนรอง :"}
              </div>
              <div
                id="CardRehabHistoryUX-div-90">
                {props.secondaryProcedure}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-91"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem", display: "flex"}}>

              <div
                id="CardRehabHistoryUX-div-92"
                style={{paddingRight: "0.5rem"}}>
                Performed start :
              </div>
              <div
                id="CardRehabHistoryUX-div-93"
                style={{width: "125px", fontWeight: "normal"}}>
                {props.performStartDate || "-"}
              </div>
              <div
                id="CardRehabHistoryUX-div-94"
                style={{paddingRight: "0.5rem"}}>
                Performed end :
              </div>
              <div
                id="CardRehabHistoryUX-div-95"
                style={{width: "125px", fontWeight: "normal"}}>
                {props.performEndDate || "-"}
              </div>
              <div
                id="CardRehabHistoryUX-div-96"
                style={{paddingRight: "0.5rem"}}>
                Performed by :
              </div>
              <div
                id="CardRehabHistoryUX-div-97"
                style={{fontWeight: "normal"}}>
                {props.data?.order_perform_by_fullname || "-"}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-98"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>
              Document Scan :
            </div>
            <div
              id="CardRehabHistoryUX-div-99">
              {props.documentScan}
            </div>
            <div
              id="CardRehabHistoryUX-div-100"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem",textDecoration: "underline"}}>
              {props.languageUX === "en" ? "Examination" : "การตรวจสอบ"}
            </div>
            <div
              id="CardRehabHistoryUX-div-101"
              style={{display: "flex",fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>

              <div
                id="CardRehabHistoryUX-div-102"
                style={{width: "95px"}}>
                {props.languageUX === "en" ? "Subjective :" : "อัตนัย :"}
              </div>
              <div
                id="CardRehabHistoryUX-div-103"
                style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
                {props.data?.subjective || "-"}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-104"
              style={{display: "flex",fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>

              <div
                id="CardRehabHistoryUX-div-107"
                style={{width: "95px"}}>
                {props.languageUX === "en" ? "Objective :" : "วัตถุประสงค์ :"}
              </div>
              <div
                id="CardRehabHistoryUX-div-112"
                style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
                {props.data?.objective|| "-"}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-105"
              style={{display: "flex",fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>

              <div
                id="CardRehabHistoryUX-div-108"
                style={{width: "95px"}}>
                {props.languageUX === "en" ? "Assessment :" : "การประเมิน :"}
              </div>
              <div
                id="CardRehabHistoryUX-div-111"
                style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
                {props.data?.assessment|| "-"}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-106"
              style={{display: "flex",fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>

              <div
                id="CardRehabHistoryUX-div-109"
                style={{width: "95px"}}>
                {props.languageUX === "en" ? "Goal :" : "เป้าหมาย :"}
              </div>
              <div
                id="CardRehabHistoryUX-div-110"
                style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
                {props.data?.goal|| "-"}
              </div>
            </div>
            <div
              id="CardRehabHistoryUX-div-113"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem"}}>
              {props.languageUX === "en" ? "Other Examination :" : "การสอบอื่นๆ :"}
            </div>
            <div
              id="CardRehabHistoryUX-div-114"
              style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
              {props.data?.other_examination|| "-"}
            </div>
            <div
              id="CardRehabHistoryUX-div-115"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem",textDecoration: "underline"}}>
              {props.languageUX === "en" ? "Treatment Details" : "รายละเอียดการรักษา"}
            </div>
            <div
              id="CardRehabHistoryUX-div-116"
              style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
              {props.data?.result|| "-"}
            </div>
            <div
              id="CardRehabHistoryUX-div-117"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem",textDecoration: "underline"}}>
              {props.languageUX === "en" ? "Post-Treatment Evaluation" : "การประเมินหลังการรักษา"}
            </div>
            <div
              id="CardRehabHistoryUX-div-118"
              style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
              {props.data?.post_treatment_evaluation|| "-"}
            </div>
            <div
              id="CardRehabHistoryUX-div-119"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem",textDecoration: "underline"}}>
              {props.languageUX === "en" ? "Recommendation & Patient Education" : "คำแนะนำและการศึกษาสำหรับผู้ป่วย"}
            </div>
            <div
              id="CardRehabHistoryUX-div-120"
              style={{fontWeight: "normal", whiteSpace: "pre-wrap"}}>
              {props.data?.recommendation_education|| "-"}
            </div>
            <div
              id="CardRehabHistoryUX-div-121"
              style={{fontWeight: "bold", margin: "1rem 0px 0.25rem",textDecoration: "underline"}}>
              {props.languageUX === "en" ? "Medication :" : "ยา :"}
            </div>
            <div
              id="CardRehabHistoryUX-div-122">
              {props.medications}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardRehabHistoryUX

export const screenPropsDefault = {}

/* Date Time : Tue Aug 26 2025 18:23:09 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"0px 10px\", paddingBottom: \"2rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการประวัติการรักษา",
          "valueEN": "Treatment History List"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\",fontSize:\"large\",color:\"rgba(0, 114, 188, 1)\",margin:\"10px 0px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form size small"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-FormGroup-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 63,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-FormField-68"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ดำเนินการ :",
          "valueEN": "Performed date :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-label-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-label-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 73,
      "name": "DateTextBox",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-DateTextBox-73"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.startDate"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 74,
      "name": "DateTextBox",
      "parent": 72,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-DateTextBox-74"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.endDate"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{display: props.data?\"\":\"none\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Divider",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-Divider-78"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"-0.25rem\", padding: \"0 1rem\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0, 114, 188, 1)\", fontWeight: \"bold\", fontSize: \"1.15rem\", display: \"flex\", alignItems: \"baseline\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "Treatment order : "
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.5rem\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.treatmentOrders"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสขั้นตอน",
          "valueEN": "Procedure code"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginTop: \"0.25rem\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "ขั้นตอนหลัก :",
          "valueEN": "Principal procedure :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.principal_procedure?.icd9cm?`[${props.data.principal_procedure.icd9cm_code}] ${props.data.principal_procedure.icd9cm_term}`:\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-88"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "ขั้นตอนรอง :",
          "valueEN": "Secondary procedure :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 86,
      "props": {
        "children": {
          "type": "code",
          "value": "props.secondaryProcedure"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-90"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\", display: \"flex\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "Performed start : "
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.performStartDate || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{width: \"125px\", fontWeight: \"normal\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "Performed end : "
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.performEndDate || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{width: \"125px\", fontWeight: \"normal\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "Performed by : "
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.order_perform_by_fullname || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "Document Scan : "
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.documentScan"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-99"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจสอบ",
          "valueEN": "Examination"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\",textDecoration: \"underline\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "อัตนัย :",
          "valueEN": "Subjective :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{width: \"95px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.subjective || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "วัตถุประสงค์ :",
          "valueEN": "Objective :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-107"
        },
        "style": {
          "type": "code",
          "value": "{width: \"95px\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมิน :",
          "valueEN": "Assessment :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{width: \"95px\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "เป้าหมาย :",
          "valueEN": "Goal :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{width: \"95px\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.goal|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.assessment|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.objective|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "การสอบอื่นๆ :",
          "valueEN": "Other Examination :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-113"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.other_examination|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการรักษา",
          "valueEN": "Treatment Details"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\",textDecoration: \"underline\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.result|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-116"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินหลังการรักษา",
          "valueEN": "Post-Treatment Evaluation"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\",textDecoration: \"underline\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.post_treatment_evaluation|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "คำแนะนำและการศึกษาสำหรับผู้ป่วย",
          "valueEN": "Recommendation & Patient Education"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\",textDecoration: \"underline\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.data?.recommendation_education|| \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", whiteSpace: \"pre-wrap\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "ยา :",
          "valueEN": "Medication :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0px 0.25rem\",textDecoration: \"underline\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.medications"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-122"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการรักษา",
          "valueEN": "Treatment history"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-123"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-div-124"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Icon",
      "parent": 124,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardRehabHistoryUX-Icon-125"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintReport"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"1rem\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 126,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardRehabHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
